import React, {useContext} from "react";
import { useTranslation } from 'react-i18next';

import LineChart from "../../d3/LineChart";
import {CountryReportData} from "../../../interfaces/RankingsAndLevelsInterfaces";
import {GlobalDataContext} from "../../../contexts/GlobalDataContext";
import {StyledSkeletonCircle} from "../../SkeletonLoader/SkeletonLoaders";
import withLoadingAnimation from "../../AnimationWrapper/AnimationWrapper";
import { formatNumberWithSymbol } from '../../../services/helpers';

import styled from 'styled-components';
import Colors from "../../../assets/colors/Colors";
import {RankingsAndLevelsContext} from "../../../contexts/RankingsAndLevelsContext";

const GraphicBoxHeader = styled.div`
  display: flex;
  flex: 0 0 auto;
  fled-direction: row;
  margin-bottom: 30px;
  width: 100%;
  max-width: 300px;
  justify-content: space-between;

  & .box-title {
    margin: auto 0;
  }

  & .box-last-value {
    font-family: DMSans-Light;
    font-size: 24px;

    .unit {
      font-size: 12px;
      margin-left: 5px;
      vertical-align: super;
    }
  }
`;

interface GraphicBoxProps {
    title: string,
    countryAllReportData?: {
        [year: string]: CountryReportData
    },
    keyData: string,
    unit?: string,
}

const GraphicBox: React.FC<GraphicBoxProps> = ({title, countryAllReportData = {}, keyData, unit}) => {
    const { t, i18n } = useTranslation();
    const lng = i18n.language || window.localStorage.i18nextLng || 'es';

    // @ts-ignore
    const { allDataLoaded } = useContext(GlobalDataContext);

    const pibValues: any = [];
    let currentValue = null;
    let currentValueNumber = null;
    let currentValueSymbol = null;

    if (Object.keys(countryAllReportData).length) {
        Object.keys(countryAllReportData).forEach((year) =>{
            // @ts-ignore
            const value = countryAllReportData[Number(year)][keyData];
            pibValues.push({x: Number(year), y: Number(value) })
        });
        //@ts-ignore
        currentValue = countryAllReportData[Object.keys(countryAllReportData).sort().pop()][keyData]
        currentValueNumber = formatNumberWithSymbol(currentValue, 2, lng)['n'];
        currentValueSymbol = formatNumberWithSymbol(currentValue, 2, lng)['symbol'];
    }

    // @ts-ignore
    const { isLife } = useContext(RankingsAndLevelsContext);
    const color = isLife ? Colors.fontWhite : Colors.fontGray;
    return (
        <div style={{display: "flex", flexDirection: "column", alignItems: 'center', color: color, height: '100%', width: '70%'}}>
            <GraphicBoxHeader>
                <div className='box-title'>{ title }</div>
                <div className='box-last-value'>
                  <span className='value'>{ currentValueNumber } </span>
                  <span className='unit'>{ currentValueSymbol } { unit }</span>
                </div>
            </GraphicBoxHeader>
            <div style={{flex: '1 0 auto', position: 'relative'}}>
                {
                    withLoadingAnimation(
                        <LineChart values={pibValues} suffix={unit}/>,
                        <StyledSkeletonCircle customStyle={{position: 'relative', top: 50, left: 100}}/>,
                        allDataLoaded
                    )
                }
            </div>
        </div>
    )
};

export default GraphicBox;
